import PaymentMethodDetailParent from "@/controllers/payment_method/payment-method-detail";

/**
 * Custom Payment Method Detail controller.
 *
 * Extends the parent controller and reuses its entire data flow. Adds a
 * currency-formatting helper used by the Custom Detail view to render the
 * current academic year opening balance in the same format used elsewhere
 * in the Payment Method module.
 */
export default {
  extends: PaymentMethodDetailParent
};
